/**
 * Terminal Component
 *
 * This component renders the TerminalDetails component within a container.
 * It also provides navigation functionality using React Router's useNavigate hook.
 *
 * @module Terminal
 */ import React from "react"
import TerminalDetails from "../components/TerminalDetails"
import "../../../src/index"

/**
 * Functional component representing the Terminal page.
 *
 * @returns {JSX.Element} The rendered Terminal component.
 */
const Terminal: React.FC = () => {
  return (
    <div className="terminal-container">
      <div className="terminal-content">
        <TerminalDetails />
      </div>
    </div>
  )
}

export default Terminal
